import moment from "moment/moment";

export function isExpired(date)
{
    return moment().isAfter(moment(date))
}

